module.exports = __webpack_public_path__ + "static/media/README.e57eb8d1.md";